// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609281706/js/" + chunkId + "." + {"44":"843e8e48","225":"85304761","481":"a032f622","486":"277f291a","770":"f33e64a7"}[chunkId] + ".0.7169292346975321.chunk.js";
};